import api from "./base-api"

const dsArchiveApiV2 = api.injectEndpoints({
    endpoints: (build) => ({
        getArchivedStateV2DS: build.query({
            query: (userId = "") => `v2/ds/archive/${userId}`
        }),
        archiveStateV2DS: build.mutation({
            query: (userId = "") => ({
                url: `v2/ds/archive/${userId}`,
                method: "POST"
            })
        }),
        restoreArchivedStateV2DS: build.mutation({
            query: (data = "") => ({
                url: `v2/ds/archive/${data.userId}/restore`,
                method: "POST"
            })
        }),
        deleteArchivedStateV2DS: build.mutation({
            query: (userId = "") => ({
                url: `v2/ds/archive/${userId}`,
                method: "DELETE"
            })
        })
    }),
    overrideExisting: false
})

export const {
    useGetArchivedStateV2DSQuery,
    useArchiveStateV2DSQuery,
    useRestoreArchivedStateV2DSMutation,
    useDeleteArchivedStateV2DSQuery
} = dsArchiveApiV2
